import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import pipeP from './utils/pipeP';
import ensureIdentity from './entity-helpers/ensureIdentity';
import chooseAndEnsurePrice from './chooseAndEnsurePrice';
import createSubjectId from './createSubjectId';
import refreshCartTotal from './refreshCartTotal';
import ensureCartElements from './ensureCartElements';

var resetRow = function resetRow(ident) {
  return function () {
    var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _extends({}, row, {
      id: row.id || createSubjectId(ident(row.product)),
      discounts: [],
      indirectSubjects: [],
      ruleFootprint: undefined
    });
  };
};

var resetCart = function resetCart(resetCb) {
  return function (_ref) {
    var payment = _ref.payment,
        shipping = _ref.shipping,
        subjects = _ref.subjects,
        rest = _objectWithoutProperties(_ref, ["payment", "shipping", "subjects"]);

    return _extends({}, rest, {
      indirectSubjects: [],
      payment: resetCb(payment),
      shipping: resetCb(shipping),
      subjects: subjects.map(resetCb)
    });
  };
};

var resolvePrices = function resolvePrices(currency, pricesType) {
  return function (_ref2) {
    var indirectSubjects = _ref2.indirectSubjects,
        payment = _ref2.payment,
        shipping = _ref2.shipping,
        subjects = _ref2.subjects,
        rest = _objectWithoutProperties(_ref2, ["indirectSubjects", "payment", "shipping", "subjects"]);

    return _extends({}, rest, {
      indirectSubjects: indirectSubjects.map(function (subject) {
        return _extends({}, subject, {
          price: chooseAndEnsurePrice(null, currency, pricesType, subject.listPrice, subject.listPriceWithTax),
          priceOriginal: chooseAndEnsurePrice(null, currency, pricesType, subject.listPrice, subject.listPriceWithTax)
        });
      }),
      payment: _extends({}, payment, {
        price: chooseAndEnsurePrice(null, currency, pricesType, payment.listPrice, payment.listPriceWithTax),
        priceOriginal: chooseAndEnsurePrice(null, currency, pricesType, payment.listPrice, payment.listPriceWithTax)
      }),
      shipping: _extends({}, shipping, {
        price: chooseAndEnsurePrice(null, currency, pricesType, shipping.listPrice, shipping.listPriceWithTax),
        priceOriginal: chooseAndEnsurePrice(null, currency, pricesType, shipping.listPrice, shipping.listPriceWithTax)
      }),
      subjects: subjects.map(function (subject) {
        return _extends({}, subject, {
          price: chooseAndEnsurePrice(null, currency, pricesType, subject.listPrice, subject.listPriceWithTax),
          priceOriginal: chooseAndEnsurePrice(null, currency, pricesType, subject.listPrice, subject.listPriceWithTax)
        });
      })
    });
  };
};

export default function applyRulesResetCart() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(processCtx) {
      var cartInput, currency, pricesType, rest, cartOriginal;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cartInput = processCtx.cart, currency = processCtx.currency, pricesType = processCtx.pricesType, rest = _objectWithoutProperties(processCtx, ["cart", "currency", "pricesType"]);
              _context.next = 3;
              return pipeP(ensureCartElements, resetCart(resetRow(ensureIdentity('entity'))), resolvePrices(currency, pricesType), refreshCartTotal)(cartInput);

            case 3:
              cartOriginal = _context.sent;
              return _context.abrupt("return", _extends({}, rest, {
                currency: currency,
                pricesType: pricesType,
                cartInput: cartInput,
                cartOriginal: cartOriginal,
                cart: _extends({}, cartOriginal)
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}